import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { TravelerInfoType } from '@pax/entities/traveler-info';
import {
  DRIVERS_TRANSLATE_KEY, GUESTS_TRANSLATE_KEY, PASSENGERS_TRANSLATE_KEY
} from '@reservation/constants/traveler-translate-keys.constants';

export function getBookingInfoTypeByTravelBookingType(booking: TravelBookingType): string {
  switch (booking) {
    case TravelBookingType.AUTOS:
      return TravelerInfoType.DRIVER;
    case TravelBookingType.HOTELS:
    case TravelBookingType.PACKAGE_AIR:
      return TravelerInfoType.GUEST;
    default:
      return TravelerInfoType.PASSENGER;
  }
}

export function getBookingInfoTypeByTravelerInfoType(type: TravelerInfoType): string {
  switch (type) {
    case TravelerInfoType.DRIVER:
      return TravelerInfoType.DRIVER;
    case TravelerInfoType.GUEST:
    case TravelerInfoType.PACKAGE_TRAVELER:
      return TravelerInfoType.GUEST;
    default:
      return TravelerInfoType.PASSENGER;
  }
}

export function getTranslateKey(type: TravelerInfoType): string {
  switch (type) {
    case TravelerInfoType.DRIVER:
      return DRIVERS_TRANSLATE_KEY;
    case TravelerInfoType.GUEST:
    case TravelerInfoType.PACKAGE_TRAVELER:
      return GUESTS_TRANSLATE_KEY;
    default:
      return PASSENGERS_TRANSLATE_KEY;
  }
}
